import React from 'react';
import { Route, Routes, BrowserRouter,HashRouter} from 'react-router-dom';

import Main from "./components/mainPage/Main";

function App() {

  return (
      
      <div>
      <HashRouter>
      {/*    <BrowserRouter basename='/Honeyboat'>*/}
      {/*/!*<BrowserRouter basename='/React'>*!/*/}
        <Routes>
          <Route exact path='/' element={<Main />}/>
        </Routes>
      </HashRouter>
      </div>
      
  )
}

export default App;
